import React from 'react';
import Banner from '../../../components/Banner/Banner';
import './YuzeyKaplamalar.css';

const YuzeyKaplamalar = () => {
  return (
    <div className="yuzey-kaplamalar-page">
      {/* Banner */}
      <Banner 
        title="Yüzey Kaplamalar" 
        backgroundImage="https://teknoma.net/wp-content/themes/bizler/assets/img/inner-banner.jpg"
      />

      {/* Page Content */}
      <section className="yuzey-kaplamalar-content">
        <div className="container content-container">
          
          {/* Introduction */}
          <div className="section introduction">
            <p>
              TeknoMa Teknolojik Malzemeler, endüstri ve son kullanıcının gereksinim duyduğu fonksiyonel ince film yüzey kaplamalarını 
              çeşitli alttaşlara uygulamaktadır.
            </p>
          </div>
          
          {/* İnce Film Uygulamaları */}
          <div className="section applications">
            <h4 className="section-heading">İnce Film Uygulamaları</h4>
            <ul>
              <li>Optik geçirgen elektriksel iletken ince filmler</li>
              <li>Işık geçirgen yansıtmasız (AR) optik filmler</li>
              <li>Tek veya çok katmanlı manyetik kaplamalar</li>
              <li>Korozyon koruma veya dekoratif amaçlı kaplamalar</li>
              <li>Takım çeliklerinin dayanım kabiliyetini arttırıcı ultra sert kaplamalar</li>
              <li>Yiyecek paketleme amaçlı polimer üzerine metalize kaplamalar</li>
              <li>Antibakteriyel kaplamalar</li>
              <li>Elektrokromik ve termokromik kaplamalar</li>
            </ul>
          </div>
          
          {/* Kullanılan Yöntemler */}
          <div className="section methods">
            <h4 className="section-heading">Kullanılan Yöntemler</h4>
            <ul>
              <li>DC ve RF Mıknatısal Sıçratma</li>
              <li>(Magnetron Sputtering)</li>
              <li>İyon Demeti Biriktirme</li>
              <li>Isıl Buharlaştirma</li>
            </ul>
          </div>
          
          {/* Kullanılan Alttaşlar */}
          <div className="section substrates">
            <h4 className="section-heading">Kullanılan Alttaşlar</h4>
            <ul>
              <li>Cam</li>
              <li>Metal</li>
              <li>Plastik (polimer)</li>
              <li>Seramik</li>
            </ul>
          </div>
          
          {/* Kaplama Malzemeleri */}
          <div className="section coating-materials">
            <h4 className="section-heading">Kaplama Malzemeleri</h4>
            <ul>
              <li>ITO</li>
              <li>TiN</li>
              <li>Al</li>
              <li>Au</li>
              <li>Al</li>
              <li>Cr</li>
              <li>Ag</li>
              <li>Ni</li>
              <li>Fe</li>
              <li>Ta</li>
              <li>TiO2</li>
              <li>Ta2O5</li>
              <li>Co</li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
};

export default YuzeyKaplamalar;
